import React, { useState, useMemo, useRef, useEffect } from 'react'
import { removeAccents } from 'utils'
import { Select, Spin } from 'antd'
import debounce from 'lodash/debounce'

//apis
import { searchAddress } from 'apis/address'
import { SearchOutlined } from '@ant-design/icons'

function DebounceSelect({ fetchOptions, debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = useState(false)
  const [options, setOptions] = useState([])
  const fetchRef = useRef(0)

  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1
      const fetchId = fetchRef.current
      setOptions([])
      setFetching(true)
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          return
        }

        setOptions(newOptions)
        setFetching(false)
      })
    }

    return debounce(loadOptions, debounceTimeout)
  }, [fetchOptions, debounceTimeout])

  return (
    <Select
      allowClear
      showSearch
      labelInValue
      suffixIcon={<SearchOutlined style={{ color: '#2099b6' }} />}
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
      //   bordered={false}
    />
  )
}

async function onSearchAddress(value) {
  try {
    if (value) {
      const res = await searchAddress({ address: removeAccents(value) })
      console.log(res)
      if (res.status === 200)
        if (res.data.success)
          return res.data.data.map((item) => ({
            label: item.description,
            value: JSON.stringify(item),
          }))
    }
    return []
  } catch (error) {
    return []
  }
}

const SearchAddress = ({ placeholder, address, setAddress, keyIndex }) => {
  // const getAddressDefault = async () => {
  //   try {
  //     const address = '515b'
  //     const res = await searchAddress({ address: removeAccents(address) })
  //     console.log(res)
  //     if (res.status === 200)
  //       if (res.data.data && res.data.data.length)
  //         setAddress({ value: res.data.data[0].place_id, label: res.data.data[0].description })
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  // useEffect(() => {
  //   getAddressDefault()
  // }, [])

  return (
    <DebounceSelect
      value={address}
      placeholder={placeholder}
      fetchOptions={onSearchAddress}
      onChange={(newValue) => {
        setAddress(newValue, keyIndex)
      }}
      style={{ width: '100%' }}
    />
  )
}

export default SearchAddress
